
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goautowarranty",
      function () {
        return require("private-next-pages/goautowarranty/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goautowarranty"])
      });
    }
  